import Image from "next/image";
import Link from "next/link";

const TwoFaOffer = () => {
  const dmAppUrl = !(typeof window === "undefined")
    ? /(localhost)|(staging)/.test(window.location.hostname)
      ? "https://staging.datamynt.com"
      : "https://datamynt.com"
    : "#";

  return (
    <div>
      Yes! To enable 2FA on your account you need to go to your profile settings
      by clicking on your name at the top right corner of the page and selecting
      “profile.” You then will be redirected to your user panel. (Or just use{" "}
      <Link href={dmAppUrl}>
        <a target="_blank" rel="noreferrer">
          this link
        </a>
      </Link>
      ).
      <br />
      <br />
      There, select “enable/disable two-factor authentication” after that you’ll
      be asked to scan a QR with an authenticator app that will give the code
      you need to enter on Data Mynt to enable 2FA.
      <div className="flex items-center justify-center">
        <Image
          width={300}
          height={170}
          alt="Two factor authentication"
          src="/twoFaFirstStep.png"
        />
      </div>
      If you don’t have an authenticator app you can download Google
      Authenticator (
      <Link href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
        <a target="_blank" rel="noreferrer">
          Android
        </a>
      </Link>
      /
      <Link href="https://apps.apple.com/us/app/google-authenticator/id388497605">
        <a>iOS</a>
      </Link>
      ), Authy (
      <Link href="https://play.google.com/store/apps/details?id=com.authy.authy">
        <a target="_blank" rel="noreferrer">
          Android
        </a>
      </Link>
      /
      <Link href="https://apps.apple.com/us/app/authy/id494168017">
        <a target="_blank" rel="noreferrer">
          iOS
        </a>
      </Link>
      ), or Microsoft Authenticator (
      <Link href="https://play.google.com/store/apps/details?id=com.azure.authenticator">
        <a target="_blank" rel="noreferrer">
          Android
        </a>
      </Link>
      /
      <Link href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458">
        <a target="_blank" rel="noreferrer">
          iOS
        </a>
      </Link>
      ).
    </div>
  );
};

export default TwoFaOffer;
